<template>
  <div id="ap-event-modal">
    <div class="top-wrapper">
      <div class="title-wrapper">
        <h1>成為 INSTO 賣家，無額外費用<br />馬上享有 Apple pay 收款功能</h1>
        <h2>下載、註冊、申請免費</h2>
      </div>
      <div
        id="ap-event-modal-closed"
        class="closed bg-contain"
        v-on:click="closed()"
      ></div>
    </div>
    <img
      src="../../assets/imgs/event/apple-pay/app-phone.png"
      class="phone-img"
      alt="download app phone"
    />
    <div class="downloads">
      <div class="app-logo bg-contain"></div>
      <a
        href="https://apps.apple.com/tw/app/id1525691104"
        target="_blank"
        rel="noopener"
        id="ap-modal-iosbtn"
      >
        <div class="ios-logo bg-contain"></div>
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.insto.instotap"
        target="_blank"
        rel="noopener"
        id="ap-modal-androidbtn"
      >
        <div class="android-logo bg-contain"></div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closed() {
      const modal = document.getElementById("ap-event-modal");
      modal.classList.remove("show");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/main.scss";
@import "@/assets/sass/foreign-credit-card.scss";

#ap-event-modal {
  display: none;
  position: fixed;
  z-index: 1000;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  padding: 54px 10px 20px 10px;
  width: 452px;
  border-radius: 30px;
  -webkit-backdrop-filter: blur(50px);
  backdrop-filter: blur(50px);
  border: 3px solid #34dc60;
  @media screen and (max-width: 768px) {
    top: 80px;
    width: 95%;
    border-radius: 20px;
    padding: 80px 10px 40px 10px;
  }
  @media screen and (max-width: 600px) {
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
    padding: 80px 10px 80px 10px;
    border: 6px solid #34dc60;
  }
}

.title-wrapper {
  h1,
  h2 {
    text-align: center;
    margin: 0;
    color: #fff;
    line-height: 1.2;
  }
  h1 {
    @media screen and (max-width: 600px) {
      font-size: 24px;
    }
  }
  h2 {
    margin-top: 12px;
    font-weight: normal;
  }
}

.closed {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 28px;
  height: 28px;
  background-image: url("../../assets/imgs/event/foreign-card/close.svg");
  z-index: 999;
  cursor: pointer;
}

.app-logo {
  background-image: url("../../assets/imgs/app-logo.png");
}

.android-logo {
  background-image: url("../../assets/imgs/download-google-play.png");
}

.ios-logo {
  background-image: url("../../assets/imgs/download-app-store.png");
}

.phone-img {
  width: auto;
  height: 300px;
  @media screen and (max-width: 600px) {
    height: 320px;
  }
}

.downloads {
  margin: 20px 0 0 0 !important;
  justify-content: center !important;
}
</style>
